exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-container[data-v-682fec71]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.c_follow[data-v-682fec71]{margin-bottom:1rem}", ""]);

// exports
